import axios from '../config'

export default {
  // 获取在线测试
  fetchTest() {
    return axios.get(`https://cdn.lessonplan.cn/Public/fetch_test.txt?flag=${new Date().getTime()}`)
  },
}